var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_close_white_responsive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_close"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62459071,4.12036426 C4.39437645,4.16213007 4.20758444,4.33050335 4.1422291,4.55516234 C4.07687376,4.77982134 4.14419777,5.02211928 4.31608301,5.18085948 L13.1278342,13.992623 L4.31608301,22.8043433 C4.15756845,22.9593233 4.09379606,23.1871084 4.14879628,23.4018655 C4.20379651,23.6166227 4.36921019,23.7857122 4.58270683,23.8454185 C4.79620346,23.9051248 5.02533495,23.8463735 5.18376091,23.6913029 L14.0147938,14.8795826 L22.826545,23.6913029 C22.9849709,23.8463735 23.2141024,23.9051248 23.4275991,23.8454185 C23.6410957,23.7857122 23.8065094,23.6166227 23.8615096,23.4018655 C23.9165098,23.1871084 23.8527374,22.9593233 23.6942229,22.8043433 L14.8824717,13.992623 L23.6942229,5.18085948 C23.8768944,5.00420905 23.9325973,4.73363963 23.8345583,4.49919856 C23.7365193,4.2647575 23.5047874,4.11438805 23.2507431,4.12036426 C23.0923089,4.12160643 22.9404226,4.18374171 22.826545,4.29389984 L14.0147938,13.1056634 L5.18376091,4.29389984 C5.06510918,4.17904509 4.90537265,4.11653949 4.74028109,4.12036426 C4.70180272,4.11674132 4.66306908,4.11674132 4.62459071,4.12036426 L4.62459071,4.12036426 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.71310e86c12f83a644abdac6793204f3.svg";
export { ForwardRef as ReactComponent };